import React, { useEffect, useState, useRef } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { content } from '../mockData';

const LongTermVisionSection = () => {
  const { language } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const visionContent = content[language].longterm;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section 
      id="longterm" 
      ref={sectionRef}
      className="section section-ivory"
    >
      <div className="container-narrow text-center">
        {/* Header */}
        <div className={`mb-48 fade-in-up ${isVisible ? 'visible' : ''}`}>
          <h2 className="mb-32">{visionContent.title}</h2>
        </div>

        {/* Platform Statement */}
        <div 
          className={`mb-64 fade-in-up ${isVisible ? 'visible' : ''}`}
          style={{
            transitionDelay: '0.2s',
            padding: '32px 40px',
            background: '#ffffff',
            border: '2px solid var(--stone)'
          }}
        >
          <p style={{ 
            fontSize: '1.125rem',
            fontWeight: 500,
            color: 'var(--olive)',
            fontStyle: 'italic',
            margin: 0
          }}>
            "{visionContent.statement}"
          </p>
        </div>

        {/* Vision Points */}
        <div style={{ textAlign: 'left' }}>
          {visionContent.vision.map((point, index) => (
            <div
              key={point}
              className={`fade-in-up ${isVisible ? 'visible' : ''}`}
              style={{
                padding: '24px 0',
                borderBottom: index < visionContent.vision.length - 1 ? '1px solid rgba(0,0,0,0.1)' : 'none',
                transitionDelay: `${0.3 + index * 0.1}s`
              }}
            >
              <p style={{ 
                fontSize: '1rem',
                margin: 0,
                paddingLeft: '32px',
                position: 'relative'
              }}>
                <span style={{
                  position: 'absolute',
                  left: 0,
                  top: '8px',
                  width: '8px',
                  height: '8px',
                  background: 'var(--gold)',
                  borderRadius: '50%'
                }} />
                {point}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LongTermVisionSection;
